<template>
  <div class="bg">
    <div class="wrapper">
      <div class="tipBox">
        <span class="warn">!</span>
        <span class="warnText">使用银行清算需进行银行卡及身份证信息认证</span>
      </div>
    </div>

    <div class="infoWrapper">
      <div class="infoLine flex">
        <div class="infoTitle">真实姓名</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.name" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">身份证号</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.certNo" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">银行卡号</div>
        <div class="infoText flex1">
          <input
            placeholder="只可绑定本人银行卡"
            @blur="getBankName"
            v-model="params.accountNo"
          />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">开户银行</div>
        <div class="infoText flex1">
          <input placeholder="" disabled="disabled" v-model="bankName" />
        </div>
      </div>
      <div class="infoLine flex">
        <div class="infoTitle">预留手机号</div>
        <div class="infoText flex1">
          <input placeholder="请输入" v-model="params.mobile" />
        </div>
      </div>
      <div class="infoLine flex" style="line-height: 24px;height: 24px;">
        <div class="infoTitle">验证码</div>
        <div class="infoText flex1">
          <input
            style="height: 24px;line-height: 24px;"
            placeholder="请输入"
            v-model="code"
          />
        </div>
        <div
          class="codeButton"
          :class="{ disabled: isDisable }"
          @click="getCode"
        >
          {{ getMobileCodeText() }}
        </div>
      </div>
    </div>

    <div class="flex buttonBox">
      <div class="nextButton flex1" @click="bind">绑定</div>
    </div>
  </div>
</template>

<script>
import {
  getCode,
  getAccountDetail,
  codeVerify,
  accountCreate
} from "@/api/bank.js";
export default {
  data() {
    return {
      id: "",
      code: "",
      bankName: "",
      params: {
        bankId: "",
        accountNo: "",
        certNo: "",
        codeRequestNo: "",
        mobile: "",
        name: "",
        requestNo: new Date().getTime()
      },
      wait_timer: false,
      isDisable: false
    };
  },
  // onLoad(option){
  // 	this.id=option.id
  //  this.getAccountDetail()
  // },
  created() {
    this.id = this.$route.query.id;
    this.getAccountDetail();
  },
  methods: {
    bind() {
      this.$vux.loading.show();
      codeVerify({
        codeRequestNo: this.params.codeRequestNo,
        verificationCode: this.code
      })
        .then(() => {
          accountCreate(this.params)
            .then(() => {
              this.$vux.loading.hide();
              this.$router.push({ path: "/bankCard/bankCard" });
            })
            .catch(err => {
              this.$vux.loading.hide();
              this.$showMessage(err);
            });
        })
        .catch(err => {
          console.log(err);
          this.$vux.loading.hide();
          this.$showMessage(err);
        });
    },
    getBankName() {
      var BIN = require("bankcardinfo");
      let that = this;
      BIN.getBankBin(this.params.accountNo, function(err, data) {
        if (!err) {
          that.bankName = data.bankName;
        } else {
          that.bankName = "";
        }
      });
    },
    getAccountDetail() {
      getAccountDetail({ id: this.id })
        .then(res => {
          this.params.bankId = res.id;
          this.params.name = res.name;
          this.params.accountNo = res.accountNumber;
          this.params.certNo = res.idNumber;
          this.params.mobile = res.phone;
          this.bankName = res.bankName;
        })
        .catch(err => {
          this.$showMessage(err);
        });
    },
    getCode() {
      let that = this;
      if (this.params.mobile) {
        this.wait_timer = 59;
        this.isDisable = true;
        let timer_interval = setInterval(function() {
          if (that.wait_timer > 0) {
            that.wait_timer--;
          } else {
            that.isDisable = false;
            clearInterval(timer_interval);
          }
        }, 1000);
        getCode({ mobile: this.params.mobile })
          .then(res => {
            this.params.codeRequestNo = res.requestNo;
          })
          .catch(err => {
            this.wait_timer = false;
            this.isDisable = false;
            this.$showMessage(err);
          });
      } else {
        this.$showMessage("请先输入预留手机号");
      }
    },
    getMobileCodeText() {
      if (this.wait_timer > 0) {
        return this.wait_timer + "s后获取";
      }

      if (this.wait_timer === 0) {
        return "重新获取";
      }

      if (this.wait_timer === false) {
        return "获取验证码";
      }
    }
  }
};
</script>

<style>
input {
  border: none;
  text-align: right;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.bg {
  background: #f3f3f3;
}
.wrapper {
  background: #feeeee;
  overflow: hidden;
  margin-bottom: 20px;
}
.tipBox {
  background: #feeeee;
  overflow: hidden;
}
.warn {
  display: block;
  width: 30px;
  height: 30px;
  border: 2px solid #eb8f8f;
  margin: 14px 20px 16px 30px;
  border-radius: 16px;
  font-size: 12px;
  line-height: 30px;
  color: #eb8f8f;
  text-align: center;
  float: left;
}
.warnText {
  display: block;
  float: left;
  font-size: 11px;
  line-height: 30px;
  padding: 14px 0 16px 0;
  color: #eb8f8f;
}
.stepBox {
  width: 100%;
  height: 130px;
  background: #fff;
  overflow: hidden;
  position: relative;
}
.bgLine {
  width: 440px;
  height: 2px;
  display: block;
  background: #dcdcdc;
  margin: 0 auto;
  margin-top: 44px;
  position: relative;
}
.step1 {
  position: absolute;
  left: -100px;
  top: -16px;
  width: 200px;
  overflow: hidden;
  z-index: 2;
}
.step2 {
  position: absolute;
  left: 120px;
  top: -16px;
  width: 200px;
  overflow: hidden;
  z-index: 2;
}
.step3 {
  position: absolute;
  right: -100px;
  top: -16px;
  width: 200px;
  overflow: hidden;
  z-index: 2;
}
.activeNum {
  width: 32px;
  height: 32px;
  background: #007bec;
  color: #fff;
  display: block;
  margin: 0 auto 14px auto;
  border-radius: 16px;
  font-size: 10px;
  line-height: 32px;
  text-align: center;
}
.unactiveNum {
  width: 28px;
  height: 28px;
  border: 2px solid #b5b5b5;
  background: #fff;
  color: #b5b5b5;
  display: block;
  margin: 0 auto 14px auto;
  border-radius: 16px;
  font-size: 10px;
  line-height: 28px;
  text-align: center;
}
.activeText {
  font-size: 12px;
  text-align: center;
  color: #007bec;
  line-height: 24px;
}
.unactiveText {
  font-size: 12px;
  text-align: center;
  color: #b5b5b5;
  line-height: 24px;
}
.infoWrapper {
  margin: 20px 0;
  overflow: hidden;
}
.infoLine {
  padding: 30px;
  background: #fff;
  border-bottom: 2px solid #f1f1f1;
}
.infoTitle {
  width: 140px;
  font-size: 14px;
  color: #474747;
  position: relative;
}
.infoText {
  text-align: right;
  font-size: 14px;
  line-height: 28px;
  color: #262626;
}
.infoText input {
  font-size: 14px;
  line-height: 28px;
  width: 100%;
  text-align: right;
}
.nextButton {
  width: 100%;
  height: 100px;
  line-height: 100px;
  font-size: 16px;
  color: #fff;
  background: #2b80fe;
  text-align: center;
}
.preButton {
  width: 250px;
  text-align: center;
  line-height: 100px;
  height: 100px;
  background: #5e5e5e;
  color: #fff;
  font-size: 15px;
}
.blueLine {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 220px;
  height: 2px;
  background: #007bec;
}
.codeButton {
  width: 180px;
  height: 48px;
  line-height: 48px;
  text-align: center;
  font-size: 12px;
  color: #fff;
  background: #007bec;
  border-radius: 10px;
  margin-left: 20px;
}
.buttonBox {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
